import type { MentorProfileDraft } from "@/lib/api/mentor-profile";
import { validatePhoneNumber } from "@/lib/utils";

export function isConfirmInfoComplete(draft: MentorProfileDraft): boolean {
  return Boolean(
    draft.first_name?.trim() &&
      draft.last_name?.trim() &&
      draft.email?.trim() &&
      draft.birthday &&
      validatePhoneNumber(draft.phone ?? "").isValid &&
      draft.sex?.trim() &&
      draft.gender_identity?.trim() &&
      draft.pronouns?.trim() &&
      draft.race?.trim(),
  );
}
